import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import {
  Card,
  Col,
  Row,
  Tooltip,
  Select,
  Space,
  Form,
  DatePicker,
  Typography,
  Spin,
} from "antd";
import upload from "../../../assets/images/upload.svg";
import ExportIcon from "../../../assets/images/export-svgrepo-com (1).svg";
import {
  TotalCustomerChart,
  CustomerPieChart,
  LoadingTimeChart,
  CustomerPieChartTOP,
  LoadingTimeChartTop,
} from "../CustomerReportAI/CustomerChartAI";
import { CALL_API } from "../../../Common/api";
import { useSelector } from "react-redux";
import { handleDownloadChart } from "../../../Reusablecomponents/Export/Exportpdf";
import dayjs from "dayjs";
const { Text } = Typography;

const Customerreportstyle = styled.div`
  .head {
    color: #5f6d8c;
  }
  .total {
    display: flex;
    align-items: center;
    justify-content: space-between !important;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .dropstyle {
    margin-top: 20px !important;
    width: 251px !important;
  }
  .dropstyle1 {
    height: 36px;
    width: 251px !important;
  }
  .badg {
    padding: 5px;
  }
  .badg .ant-badge-count {
    font-size: 12px; /* Adjust the count number size */
    height: 16px; /* Decrease the outer circle height */
    min-width: 16px; /* Decrease the outer circle width */
    line-height: 16px; /* Center the count text vertically */
  }

  .plc .ant-select-selection-placeholder {
    color: black !important; /* Set placeholder text color to black */
  }

  .plc .ant-select-arrow {
    color: black; /* Set dropdown arrow color to black */
  }

  .ant-card-head {
    border-bottom: none;
  }
  .topcustomer-content {
    display: flex;
    align-item: center;
    justify-content: space-between;
    background-color: yellowgreen;
  }
     .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  },
`;

const topcustomercolors = [
  "#00BC13",
  "#DEE640",
  "#FC8954",
  "#0090EA",
  "#89C8FF",
];
// const bottomcustomerdata = [
//   { CompanyName: "Pwani Oil Mombasa", value: 25 },
//   { CompanyName: "Edible Oil Products", value: 24 },
//   { CompanyName: "Adesh Limited", value: 20 },
//   { CompanyName: "Golden Africa Kenya", value: 15 },
//   { CompanyName: "New Oswal", value: 10 },
// ];
const bottomcustomercolors = [
  "#04A093",
  "#40E6E4",
  "#0090BC",
  "#89C0FF",
  "#22A5F6",
];
//time after loading(Hr) PieChart colors
const TimeAfterTopcolors = [
  "#89C8FF",
  "#00EAE6",
  "#E373FF",
  "#40E659",
  "#94FF5F",
];
const TimeAfterBottomcolors = [
  "#E3DC1B",
  "#1BEA00",
  "#FF8B73",
  "#F46ECE",
  "#84D6FC",
];

const CustomerReportAI = () => {
  const [visible, setVisible] = useState(false);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [chartData, setChartData] = useState([]);
  const [loadingchartData, setloadingchartData] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [duration, setDuration] = useState("current_month");
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleTooltipVisibleChange = (visible) => {
    setVisible(visible);
  };
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("AICUSTRPT", "EX"),
    [reduxPermissions],
  );
  const getCustomerChart = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "POST",
      `aiReport/customer/get_CustomerReport?MCID=${
        userInfo.MCID
      }&startDate=${dayjs(selectedDate?.[0]).format(
        "YYYY-MM-DD",
      )}&endDate=${dayjs(selectedDate?.[1]).format("YYYY-MM-DD")}`,
    );

    setChartData(data);
    setLoading(false);
  };

  useEffect(() => {
    if (selectedDate?.length === 2) {
      setDateRange(selectedDate);
      getCustomerChart();
    }
  }, [selectedDate, userInfo]);

  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];
  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  return (
    <div>
      <Customerreportstyle>
        <Col sm={24} xl={24} md={24}>
          <Card>
            <div className="total">
              <div>Overiew</div>
              <div className="Custom">
                <div className="dropstyle">
                  {" "}
                  <Form.Item
                    label=""
                    name="dropdown"
                    rules={[
                      { required: true, message: "Please select an option!" },
                    ]}
                  >
                    <Select
                      placeholder="Custom Range"
                      className="plc"
                      style={{ width: "240px" }}
                      defaultValue={duration}
                      onChange={(values) => {
                        setDuration(values);
                      }}
                    >
                      {Duration.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item?.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="dropstyle1">
                  <Space direction="vertical" size={12}>
                    <RangePicker
                      value={selectedDate}
                      onChange={(date, dateString) => setSelectedDate(date)}
                    />
                  </Space>
                </div>
                {/* <div>
                    <Tooltip
                      title="Export"
                      placement="bottom"
                      arrow={false}
                      visible={visible}
                      onVisibleChange={handleTooltipVisibleChange}
                      //   overlayInnerStyle={{
                      //     backgroundColor: "transparent",
                      //     color: "#5f6d8c",
                      //     boxShadow: "none",
                      //   }}
                    >
                      <img
                        src={upload}
                        alt="Upload Icon"
                        className="hover-image"
                        onClick={() => handleDownloadChart("Export Chart")}
                      />
                    </Tooltip>
                  </div> */}
              </div>
            </div>
          </Card>
        </Col>
        <div>
          <div id="Export Chart">
            <Col sm={24} xl={24} md={24} className="mt-3">
              <Spin spinning={loading}>
                <Card
                  title={
                    <div className="chart-header">
                      <span>
                        Total Customer (Consignee)
                        <span
                          style={{
                            fontSize: "32px",
                            marginLeft: "20px",
                            alignContent: "center",
                          }}
                        >
                          {chartData?.Customer_Total?.length || 0}
                        </span>
                      </span>
                      <div>
                        <img
                          src={ExportIcon}
                          alt="Export"
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: exportAllowed ? "pointer" : "not-allowed",
                            backgroundColor: "#EBF7ED",
                            borderRadius: "6px",
                          }}
                          onClick={() => {
                            if (!exportAllowed) return;

                            handleDownloadChart(
                              "Export Chart",
                              "Total Customer",
                            );
                          }}
                        />
                      </div>
                    </div>
                  }
                >
                  <TotalCustomerChart
                    data={
                      chartData.Customer_Total ? chartData.Customer_Total : []
                    }
                    width="100%"
                    height={350}
                  />
                </Card>
              </Spin>
            </Col>
          </div>
          <div id="Export Chart1">
            <Card
              className="w-100 mt-3"
              title={
                <div className="chart-header">
                  <div className="total">
                    <span>Offloading Cycle (Hr)</span>
                  </div>
                  <div>
                    <img
                      src={ExportIcon}
                      alt="Export"
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                        backgroundColor: "#EBF7ED",
                        borderRadius: "6px",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart("Export Chart1", "Offloading Time");
                      }}
                    />
                  </div>
                </div>
              }
            >
              <Row gutter={16}>
                <Col sm={24} md={12} xl={12}>
                  <Spin spinning={loading}>
                    <Card>
                      <h6>Top 5 Customers</h6>

                      <CustomerPieChartTOP
                        data={
                          Array.isArray(chartData.OffLoadingCycleTop)
                            ? chartData.OffLoadingCycleTop
                            : []
                        }
                        colors={topcustomercolors}
                      />
                    </Card>
                  </Spin>
                </Col>
                <Col sm={24} md={12} xl={12}>
                  <Spin spinning={loading}>
                    <Card>
                      <h6>Bottom 5 Customers</h6>

                      <CustomerPieChart
                        // Forces re-render
                        data={
                          Array.isArray(chartData.OffLoadingCycleBottom)
                            ? chartData.OffLoadingCycleBottom
                            : []
                        }
                        width="100%"
                        height={350}
                        // data={bottomcustomerdata}
                        colors={bottomcustomercolors}
                      />
                    </Card>
                  </Spin>
                </Col>
              </Row>
            </Card>
          </div>

          <div id="Export Chart4">
            <Card
              className="mt-3"
              title={
                <div className="chart-header">
                  <div className="total">
                    <span>Loading Cycle(Hr)</span>
                  </div>
                  <div>
                    <img
                      src={ExportIcon}
                      alt="Export"
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                        backgroundColor: "#EBF7ED",
                        borderRadius: "6px",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart("Export Chart4", "Loading Time");
                      }}
                    />
                  </div>
                </div>
              }
            >
              <Row gutter={16}>
                <Col sm={24} md={12} xl={12}>
                  <Spin spinning={loading}>
                    <Card>
                      <h6>Top 5 Customers</h6>
                      {Array.isArray(chartData?.LoadingCycleTop) &&
                        chartData.LoadingCycleTop?.length > 0 && (
                          <LoadingTimeChartTop
                            data={chartData.LoadingCycleTop}
                            color="#126DF6"
                            width="100%"
                            height={250}
                          />
                        )}
                    </Card>
                  </Spin>
                </Col>

                <Col sm={24} md={12} xl={12}>
                  <Spin spinning={loading}>
                    <Card>
                      <h6>Bottom 5 Customers</h6>
                      {Array.isArray(chartData?.LoadingCycleBottom) &&
                        chartData.LoadingCycleBottom?.length > 0 && (
                          <LoadingTimeChart
                            data={chartData.LoadingCycleBottom}
                            color="#09D982"
                            width="100%"
                            height={250}
                          />
                        )}
                    </Card>
                  </Spin>
                </Col>
              </Row>
            </Card>
          </div>
        </div>
      </Customerreportstyle>
    </div>
  );
};

export default CustomerReportAI;
